import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=3ec1716a&"
import script from "./BaseAccordion.vue?vue&type=script&lang=js&"
export * from "./BaseAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec1716a')) {
      api.createRecord('3ec1716a', component.options)
    } else {
      api.reload('3ec1716a', component.options)
    }
    module.hot.accept("./BaseAccordion.vue?vue&type=template&id=3ec1716a&", function () {
      api.rerender('3ec1716a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseAccordion.vue"
export default component.exports